import React from "react";
import PropTypes from "prop-types";
import Drawer from "@material-ui/core/Drawer";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Close } from "@material-ui/icons";
import { useSelector } from "react-redux";

const styles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  drawerPaper: {
    ...theme.typography.defaultFont,
    //  width: "25%",
    height: "100%",
    borderRadius: "25px 0 0px 25px",
    padding: "30px",
    ["@media (max-width:576px)"]: {
      borderRadius: "25px 25px 0px 0px",
      width: "100%",
      padding: "20px",
      height: "auto"
    }
  },
  close: { display: "flex", justifyContent: "flex-end" }
}));

const CustomDrawer = props => {
  const classes = styles();
  const {
    isOpen,
    toggleDrawer,
    isCloseButton,
    children,
    anchor,
    customClass,
    closeBtnStyle,
    backdropClose = true
  } = props;
  const isMobile = useSelector(state =>
    state.commonReducer.deviceType === "desktop" ? false : true
  );

  const onDrawerClose = reason => {
    if (reason === "backdropClick" && !backdropClose) {
      return;
    } else {
      toggleDrawer(reason);
    }
  };

  return (
    <div className={classes.root}>
      <Drawer
        variant="temporary"
        anchor={anchor ? anchor : isMobile ? "bottom" : "right"}
        open={isOpen}
        onClose={(ev, reason) => onDrawerClose(reason)}
        classes={
          customClass ? { paper: customClass } : { paper: classes.drawerPaper }
        }
      >
        {isCloseButton && (
          <div className={classes.close}>
            <IconButton className={closeBtnStyle} onClick={toggleDrawer}>
              <Close fontSize="small" />
            </IconButton>
          </div>
        )}
        {children}
      </Drawer>
    </div>
  );
};

CustomDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  isCloseButton: PropTypes.bool
};

export default CustomDrawer;
